import React from 'react'
import PropTypes from 'prop-types'

const UploadImageIcon = (props) => {
  const { color = '#262626', classes = 'w-20' } = props
  return (
    <svg
      className={classes}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9870_41265)">
        <path
          d="M2.5 3.33398V0.833984H4.16667V3.33398H6.66667V5.00065H4.16667V7.50065H2.5V5.00065H0V3.33398H2.5ZM5 8.33398V5.83398H7.5V3.33398H13.3333L14.8583 5.00065H17.5C18.4167 5.00065 19.1667 5.75065 19.1667 6.66732V16.6673C19.1667 17.584 18.4167 18.334 17.5 18.334H4.16667C3.25 18.334 2.5 17.584 2.5 16.6673V8.33398H5ZM10.8333 15.834C13.1333 15.834 15 13.9673 15 11.6673C15 9.36732 13.1333 7.50065 10.8333 7.50065C8.53333 7.50065 6.66667 9.36732 6.66667 11.6673C6.66667 13.9673 8.53333 15.834 10.8333 15.834ZM8.16667 11.6673C8.16667 13.1423 9.35833 14.334 10.8333 14.334C12.3083 14.334 13.5 13.1423 13.5 11.6673C13.5 10.1923 12.3083 9.00065 10.8333 9.00065C9.35833 9.00065 8.16667 10.1923 8.16667 11.6673Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_9870_41265">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

UploadImageIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(UploadImageIcon)
